module.exports = __webpack_public_path__ + "img/3.e31bb252.jpg";